(() => {
  'use strict';
  let removing = false;
  const bundleIds = new Set(["db38b93b-8e81-4ed5-832b-1fca2400325e", "36cc0bd6-5894-42c4-bb78-be2cfa779d2a", "eefb51a7-5c28-425e-9291-db689a4b0ae6", "d1e388a7-b463-4b5e-b50c-5bbc00378c7a", "23ff4b30-f465-4d47-b31b-0f2c6b70f50a"]);
  const parse = (html) => new DOMParser().parseFromString(html, 'text/html');

  // A fixed bundle and its gift are removed together. Other lines, including
  // separate purchases of the same variant, keep their original properties.
  document.addEventListener('click', async (event) => {
    const remove = event.target.closest('cart-remove-button');
    const row = remove?.closest('[data-sv-cart-role="primary"]');
    if (!row || !bundleIds.has(row.dataset.svCartBundle)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (removing) return;
    removing = true;
    const drawer = remove.closest('cart-drawer');
    const button = remove.querySelector('button');
    if (button) button.disabled = true;
    row.setAttribute('aria-busy', 'true');
    const root = window.Shopify?.routes?.root || '/';
    try {
      const currentResponse = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      if (!currentResponse.ok) throw new Error('cart_read_failed');
      const current = await currentResponse.json();
      const selected = current.items.find(item => item.key === row.dataset.svCartKey);
      if (!selected) throw new Error('cart_changed');
      const properties = selected.properties || {};
      const sameOffer = item => ['_zyberon_bundle_id', '_zyberon_bundle_version', '_zyberon_bundle_offer', '_zyberon_bundle_signature', '_zyberon_bundle_tier'].every(key => item.properties?.[key] === properties[key]);
      const hasOtherPrimary = current.items.some(item => item.key !== selected.key && item.properties?._zyberon_bundle_role === 'primary' && sameOffer(item));
      const updates = { [selected.key]: 0 };
      for (const item of current.items) {
        const candidate = item.properties || {};
        if (!hasOtherPrimary && candidate._zyberon_bundle_role === 'gift' && sameOffer(item)) updates[item.key] = 0;
      }
      const specs = [
        { section: 'cart-drawer', selector: 'cart-drawer .drawer__inner' },
        { section: 'cart-icon-bubble', selector: '#cart-icon-bubble', inner: true },
      ];
      const items = document.getElementById('main-cart-items');
      const footer = document.getElementById('main-cart-footer');
      if (items) specs.push({ section: items.dataset.id, selector: 'cart-items' });
      if (footer) specs.push({ section: footer.dataset.id, selector: '#main-cart-footer' });
      const response = await fetch(`${root}cart/update.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates, sections: specs.map(spec => spec.section), sections_url: location.pathname }),
      });
      const state = await response.json();
      if (!response.ok || state.errors) throw new Error('cart_update_failed');
      for (const spec of specs) {
        const target = document.querySelector(spec.selector);
        if (!target) continue;
        const html = state.sections?.[spec.section];
        const source = html && parse(html).querySelector(spec.selector === '#cart-icon-bubble' ? '.shopify-section' : spec.selector);
        if (!source) { location.reload(); return; }
        if (spec.inner) target.innerHTML = source.innerHTML;
        else target.replaceWith(source);
      }
      const currentDrawer = document.querySelector('cart-drawer');
      currentDrawer?.classList.toggle('is-empty', state.item_count === 0);
      if (drawer && currentDrawer) {
        const container = state.item_count ? currentDrawer.querySelector('.drawer__inner') : currentDrawer.querySelector('.drawer__inner-empty');
        const focusTarget = container?.querySelector('a,button');
        if (container && typeof window.trapFocus === 'function') window.trapFocus(container, focusTarget);
        else focusTarget?.focus();
      } else {
        const title = document.querySelector('cart-items h1');
        title?.setAttribute('tabindex', '-1');
        title?.focus({ preventScroll: true });
      }
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: state });
    } catch (_) {
      const error = document.getElementById(drawer ? 'CartDrawer-CartErrors' : 'cart-errors');
      if (error) error.textContent = 'We could not update your cart. Please refresh the page and try again.';
    } finally {
      removing = false;
      if (button?.isConnected) button.disabled = false;
      if (row.isConnected) row.removeAttribute('aria-busy');
    }
  }, true);

  // The offer is rendered asynchronously by the bundle app, so a cart link
  // to its anchor must wait for that element before scrolling.
  if (/^#zyberon-bundle-auto-\d+$/.test(location.hash)) {
    const scrollToOffer = () => {
      const offer = document.getElementById(location.hash.slice(1));
      if (!offer || !offer.querySelector('.zyb-offer')) return false;
      offer.scrollIntoView({ block: 'start', behavior: 'auto' });
      return true;
    };
    if (!scrollToOffer()) {
      const observer = new MutationObserver(() => { if (scrollToOffer()) observer.disconnect(); });
      observer.observe(document.body, { childList: true, subtree: true });
      setTimeout(() => observer.disconnect(), 15000);
    }
  }
})();
